window.addEventListener('b4bVariantsDisplayed', function(e) {
    //const variantsArray = Object.values(e.detail.variants);
    const variantsItems = document.querySelectorAll('#product-grid .grid__item');
    let influencer = document.querySelector('#product-grid');
    let indexCount = 0;

    setTimeout(() => {
        variantsItems.forEach(item => {
            const handle = item.getAttribute('data-handle');
            let vComparePrice = '';
            let vSalePrice = '';

            // for influencer grid only
            if(influencer.classList.contains('is-influencer')){
                if(!item.classList.contains('influencer-promo')){
                    item.style.order = indexCount + 1;
                    indexCount = indexCount+1;
                }
            }
            // end of influencer code

            item.classList.add('b4b-activated');
            let isAvailable = true;
            if(item.getAttribute('data-unavailable') === 'true')
                isAvailable = false;

            const perRowView = document.querySelector('#product-grid');

            if(perRowView.classList.contains('grid--4-col-desktop')){
                perRowView.classList.remove('grid--4-col-desktop');
            }

            const variantID = item.getAttribute('data-variant-id');
            const showColorSwatchB4bSplit = perRowView.getAttribute('data-show-color-swatch-b4b-split') === 'true';
            if (variantID) {
                if (showColorSwatchB4bSplit) {
                    const uniqueId = item.id || Math.random().toString(36).substring(2, 7);

                    // Isolate all radio inputs inside THIS specific product card
                    const cardInputs = item.querySelectorAll('pcard-variant input[type="radio"]');
                    cardInputs.forEach(input => {
                        // Only modify the name if we haven't scoped it yet to prevent infinite appending
                        if (!input.dataset.nameScoped) {
                            input.name = `${input.name}_${uniqueId}`;
                            input.dataset.nameScoped = "true";
                        }
                    });

                    // Find the input element by looking up variant options from product JSON
                    const productJsonScript = item.querySelector('script[type="application/json"]');
                    if (productJsonScript) {
                        let productVariants = [];
                        try {
                            productVariants = JSON.parse(productJsonScript.textContent);
                        } catch (e) {}

                        const variant = productVariants.find(v => v.id.toString() === variantID.toString());
                        if (variant) {
                            ['option1', 'option2', 'option3'].forEach(opt => {
                                if (variant[opt]) {
                                        const variantFieldset = item.querySelector(`pcard-variant input[value="${variant[opt]}"]`);
                                        if (variantFieldset) {
                                            variantFieldset.checked = true;
                                            variantFieldset.setAttribute("checked", "checked");
                                            variantFieldset.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
                                        }
                                }
                            });
                        }
                    }
                } else {
                    item.querySelectorAll('pcard-variant fieldset').forEach(fs => {
                        if (fs && fs.classList) {
                          fs.classList.add('d-none');
                        }
                    });
                }
            }

            const atcButton = item.querySelector('product-form button');
            if(!isAvailable && atcButton) {
							atcButton.disabled = true;
							atcButton.querySelector('.js-main-button-span').textContent = 'Sold Out';
            }



            // to show badge based on variant metafield
            if(variantID){
							let badgeParent = item.querySelector('.card-wrapper');
							let variantJs = item.querySelector(`pcard-variant .pcard-variants__badge`);
							if(!variantJs) return;
							let variantList = variantJs.querySelector(`li[data-vid="${variantID}"]`);
							vComparePrice = variantList.getAttribute('data-compare-at');
							vSalePrice = variantList.getAttribute('data-sale-price');

							if(variantList.getAttribute('data-vbadge') == 'True' && badgeParent.getAttribute('data-show-badge') == 'true'){
								let badgeWrapper = badgeParent.querySelector('.card__inner .badge-wrapper');
								let badgeElementText = badgeWrapper.getAttribute('data-badge-text') || 'Final Sale';
								let badgeElement = document.createElement('span');
									badgeElement.className = 'show-badge d-flex product-tag tag caption-sm mt-1 mt-md-2 px-3 fw-medium d-inline-block text-capitalize tag-yellow';
									badgeElement.textContent = badgeElementText;
								if(!badgeWrapper.querySelector('.show-badge')){
									badgeWrapper.append(badgeElement);
								}
								else{
									badgeWrapper.querySelector('.show-badge').remove();
									badgeWrapper.append(badgeElement);
								}
							}
              // To show final sale badge based on selected variant
              getFinalSaleBadge(variantID, item);
            }


            //compare at price issue fix
            if(vComparePrice && vSalePrice){
                let sale_price = `<div class="price__sale" bis_skin_checked="1">
                    <div class="d-flex" bis_skin_checked="1">
                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                        <span>
                        <s class="price-item d-block price-item--regular text-classic-blue b4b-vprice">
                            ${vComparePrice}
                        </s>
                        </span><span class="visually-hidden visually-hidden--inline">Sale price</span>
                    <span class="price-item d-block price-item--sale price-item--last text-chilli-red b4b-compare-at-price">${vSalePrice}</span>
                    </div>
                </div>`;

                let priceWrapper = item.querySelector(`.card__content [data-price="price__js"]`);
                if(!priceWrapper.querySelector('.price').classList.contains('price--on-sale')){
									priceWrapper.querySelector('.price').classList.add('price--on-sale');
									priceWrapper.querySelector('.price .price__container').innerHTML=sale_price;
                }
            }

            // code to ignore split for products
            /*
            // Count repeated handles
            const counts = variantsArray.reduce((acc, item) => {
                acc[item.handle] = (acc[item.handle] || 0) + 1;
                return acc;
            }, {});
            // If handle is repeated, hide all fieldsets
            if (counts[handle] > 1) {
                item.querySelectorAll('pcard-variant fieldset').forEach(fs => {
                    if (fs && fs.classList) {
                        fs.classList.add('d-none');
                    }
                });
            }*/
        });
    }, 500);
    function getFinalSaleBadge(variantID, item){
        let badgeParent = item.querySelector('.card-wrapper');
        let variantJs = item.querySelector(`pcard-variant .pcard-variants__final_sale_badge`);
        if(!variantJs) return;
        let variantList = variantJs.querySelector(`li[data-final-vid="${variantID}"]`);
        const finalSaleBadgeBlock = badgeParent.querySelector(".product-final-sale");

        if(finalSaleBadgeBlock && variantList)
          finalSaleBadgeBlock.innerHTML = variantList.innerHTML;
    }
});
